import AdvertisingPageDataValueObject from './AdvertisingPageDataValueObject.js'
import AdvertisingValueObject from './AdvertisingValueObject.js'
import DisplayAdvertisingValueObject from './DisplayAdvertisingValueObject.js'
import {SaitamaConfigurationValueObject} from './SaitamaConfigurationValueObject.js'

export default class AdvertisingValueObjectsFactory {
  static displayAdvertisingValueObject = ({url, positions}) => new DisplayAdvertisingValueObject({url, positions})

  static saitamaConfigurationValueObject = ({brandDayEnabled}) => new SaitamaConfigurationValueObject({brandDayEnabled})

  static advertisingValueObject = params => new AdvertisingValueObject(params)

  static advertisingPageDataValueObject = ({page_name: pageName, url, segmentation}) =>
    new AdvertisingPageDataValueObject({
      url,
      page_name: pageName,
      segmentation: AdvertisingValueObjectsFactory.advertisingValueObject(segmentation)
    })
}
